import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SpinnerService } from 'shared-components';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EtiquetadoService } from "../../../../services/etiquetado.service";

@Component({
    selector: 'app-cajas-pallet-component',
    templateUrl: './cajas-pallet.component.html'
})
export class CajasPalletComponent implements OnInit, OnDestroy {

    public cajasForm: UntypedFormGroup;
    public showError = false;
    public _editable: boolean;

    public confeccionesCaja;

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledCajas: Subject<boolean> = new Subject();

    private readonly destroy$ = new Subject<void>();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.cajasForm) {
            if (value) {
                this.cajasForm.enable();
                this.cajasForm.get('id').patchValue(this.idTabla);
            } else {
                this.cajasForm.disable();
                this.disabledDenominaciones.next(true);
                this.disabledCajas.next(true);
                this.cajasForm.patchValue({
                    id: this.caja.idTabla,
                    denominacion: this.denominaciones.find(x => x.id === this.caja.denominacionId),
                    cantidad: this.caja.cantidad
                });
            }
        }
    }

    @Input() idTabla;
    @Input() denominaciones;
    @Input() etiquetadorId;
    @Input() caja?;

    @Output() refreshAdd = new EventEmitter<any>();
    @Output() refreshRemove = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private _spinnerService: SpinnerService,
        private _etiquetadoService: EtiquetadoService) { }

    ngOnInit() {
        this.cajasForm = this._fb.group({
            id: [{ value: '', disabled: true }, Validators.required],
            denominacion: [{ value: '', disabled: !this.editable }, Validators.required],
            caja: [{ value: '', disabled: true }, Validators.required],
            cantidad: [{ value: 1, disabled: !this.editable }, Validators.required],
        });

        if (this.caja) {
            this.cajasForm.disable();
            this.disabledDenominaciones.next(true);
            this.disabledCajas.next(true);
            this.cajasForm.patchValue({
                id: this.caja.idTabla,
                denominacion: this.denominaciones.find(x => x.id === this.caja.denominacionId),
                caja: this.caja,
                cantidad: this.caja.cantidad
            });
        } else {
            this.cajasForm.get('id').patchValue(this.idTabla);
        }

        this.cajasForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                let _filters = {
                    etiquetadorId: this.etiquetadorId,
                    denominacionIdUnica: denominacion.id,
                    tipoConfeccionId: 1,
                    confeccionMix: denominacion.id ? false : true
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.getConfecciones(_filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.confeccionesCaja = resp.lista;
                        this.cajasForm.get('caja').enable();
                        this.disabledCajas.next(false);
                    } else {
                        this.cajasForm.get('caja').disable();
                        this.disabledCajas.next(true);
                    }
                });
            } else {
                this.confeccionesCaja = [];
                this.cajasForm.get('caja').disable();
                this.disabledCajas.next(true);
            }

            if (this.caja) {
                this.cajasForm.get('caja').patchValue(this.confeccionesCaja.find())
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public save() {
        this.checkForm();
        if (this.cajasForm.valid) {
            const _caja = {
                idTabla: this.cajasForm.get('id').value,
                id: this.cajasForm.get('caja').value.id,
                denominacionId: this.cajasForm.get('denominacion').value.id,
                peso: this.cajasForm.get('caja').value.kilos,
                des: this.cajasForm.get('caja').value.des,
                cantidad: this.cajasForm.get('cantidad').value
            };
            this.refreshAdd.emit(_caja);
            this.cajasForm.disable();
            this.disabledCajas.next(true);
        }
    }

    public remove() {
        this.refreshRemove.emit(this.caja);
    }

    public cancel() {
        if (!this.caja) {
            this.close.emit(false);
        }
    }

    private checkForm() {
        this.showError = this.cajasForm.invalid;
    }
}
